<template>
  <div class="mainContent">

    <component
      v-if="wasMounted && fieldSchema.type != 'none'"
      v-for="fieldSchema in fields" :key="fieldSchema.name"
      ref="fields"
      :is="typeToComponent(fieldSchema.type)"
      :schema="fieldSchema" :warehouseId="warehouseId"
      v-model="value" @change="onChange" />

  </div>
</template>

<script>
import StringField from '../fields/StringField.vue';
import BooleanField from '../fields/BooleanField.vue';
import GroupField from '../fields/GroupField.vue';
import OptionField from '../fields/OptionField.vue';
import ChoiceField from '../fields/ChoiceField.vue';
import ListOptionField from '../fields/ListOptionField.vue';

export default {
  name: 'base-form',
  components: {
    StringField,
    BooleanField,
    GroupField,
    OptionField,
    ChoiceField,
    ListOptionField,
    'base-form': () => import('./BaseForm.vue'),
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    warehouseId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      alreadyChecked: false,
      wasMounted: false,
    };
  },
  mounted() {
    this.wasMounted = true;
  },
  computed: {
  },
  methods: {

    typeToComponent(fieldType) {
      switch (fieldType) {
        case 'boolean':
          return 'BooleanField';
        case 'group':
          return 'GroupField';
        case 'option':
          return 'OptionField';
        case 'list':
          return 'ListOptionField';
        case 'string':
        case 'password':
          return 'StringField';
        case 'choice':
          return 'ChoiceField';
        default:
          return `unknown:${fieldType}`;
      }
    },

    validateConfig() {
      return this.validate();
    },

    validate() {
      let valid = true;
      for (const field of this.$refs.fields) {
        field.showWarnings = true;
        if (field.validate && !field.validate()) {
          valid = false;
        }
      }
      return valid;
    },

    onChange() {
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__input {

    &__field {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/base/BaseForm.vue